import { render, staticRenderFns } from "./PickupInfo.vue?vue&type=template&id=1ff0c282&scoped=true"
import script from "./PickupInfo.vue?vue&type=script&lang=js"
export * from "./PickupInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff0c282",
  null
  
)

export default component.exports